module.exports = __webpack_public_path__ + "img/herbe.fb7b0006.png";